import { MappableModel } from './mappable-model'

export class FeatureToggle extends MappableModel {
  public id: number
  public label: string
  public key: string
  public enabled: boolean
  public can_use: boolean
  public user_controlled: boolean
}
